export const questionOptionFields = [
	{
		title: "Answer",
		key_name: "option",
		type: "input",
		value: "",
	},
	{
		title: "Is This correct answer?",
		key_name: "isCorrect",
		type: "switch",
		value: false,
	},
];
